<template>
  <div class="sorting-box-list">
    <!-- 搜索表单 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" class="search-form">
        <a-row :gutter="16">
          <!-- 第一行：常显搜索项 -->
          <a-col :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <a-form-item label="包号" class="search-form-item">
              <a-input
                  v-model="queryParam.boxNum"
                  placeholder="请输入包号"
                  allowClear
              />
            </a-form-item>
          </a-col>

          <a-col v-show="!hasSiteId" :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <a-form-item label="始发地" class="search-form-item">
              <a-select
                  v-model="queryParam.originationId"
                  placeholder="请选择始发地"
                  show-search
                  allowClear
                  :filter-option="filterOption"
              >
                <a-select-option value="">全部</a-select-option>
                <a-select-option v-for="site in selectedItems" :key="site.id" :value="site.id">
                  {{ site.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <a-form-item label="目的地" class="search-form-item">
              <a-select
                  v-model="queryParam.siteId"
                  placeholder="请选择目的地"
                  show-search
                  allowClear
                  :filter-option="filterOption"
              >
                <a-select-option value="">全部</a-select-option>
                <a-select-option v-for="site in selectedItems" :key="site.id" :value="site.id">
                  {{ site.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <a-form-item label="发运状态" class="search-form-item">
              <a-select
                  v-model="queryParam.shippingStatus"
                  placeholder="请选择发运状态"
                  allowClear
              >
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="0">待发运</a-select-option>
                <a-select-option :value="1">已发运</a-select-option>
                <a-select-option :value="2">运输中</a-select-option>
                <a-select-option :value="4">已完成</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <a-form-item label="装袋状态" class="search-form-item">
              <a-select
                  v-model="queryParam.baggingStatus"
                  placeholder="请选择装袋状态"
                  allowClear
              >
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="0">装袋中</a-select-option>
                <a-select-option :value="1">已完成</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <!-- 操作按钮 -->
          <a-col :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
            <a-form-item class="search-form-item search-buttons">
              <a-space size="middle">
                <a-button type="primary" icon="search" @click="searchQuery()">
                  查询
                </a-button>
                <a-button icon="reload" @click="searchReset({},0);">
                  重置
                </a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
        class="sorting-table"
        :columns="columns"
        :dataSource="dataSource"
        rowKey="id"
        :pagination="ipagination"
        :loading="loading"
        bordered
        @change="handleTableChange"
    >
      <template slot="boxNum" slot-scope="text, record">
        <a @click="handleViewBox(record)">{{ text }}</a>
      </template>

      <template slot="shippingStatus" slot-scope="text">
        <a-tag :color="getStatusColor(text)">
          {{ getStatusText(text) }}
        </a-tag>
      </template>

      <template slot="baggingStatus" slot-scope="text">
        <a-tag :color="text == 1 ? 'green' : 'orange'">
          {{ text == 1 ? '已完成' : '装袋中' }}
        </a-tag>
      </template>
    </a-table>

    <!-- 订单子组件 -->
    <order-list-modal
        :visible="orderModalVisible"
        :boxNum="currentBoxNum"
        @close="handleOrderModalClose"
    />
  </div>
</template>

<script>
import OrderListModal from './modules/OrderListModal.vue'
import {mapGetters} from 'vuex'
import {TableListMixin} from '@/situation/mixins/tableListMixin'

export default {
  mixins: [TableListMixin],
  components: {
    OrderListModal
  },
  mounted() {
    this.selectedItemsAll = this.siteInfo()
    console.log('hasSiteId', this.hasSiteId);
    this.selectedItems = JSON.parse(JSON.stringify(this.selectedItemsAll))
  },
  data() {
    return {
      queryParam: {},
      searchForm: this.$form.createForm(this),
      selectedItemsAll: [],
      hasSiteId: !!this.userInfo().siteId,
      selectedItems: [],
      columns: [
        {
          title: '包号',
          dataIndex: 'boxNum',
          align: 'center',
          // width: 200,
          scopedSlots: {customRender: 'boxNum'}
        },
        {
          title: '始发地',
          align: 'center',
          // width: 200,
          dataIndex: 'originationName'
        },
        {
          title: '目的地',
          align: 'center',
          // width: 200,
          dataIndex: 'siteName'
        },
        {
          title: '总件数(个)',
          align: 'center',
          width: 100,
          dataIndex: 'totalCount'
        },
        {
          title: '总重量(kg)',
          align: 'center',
          width: 100,
          dataIndex: 'totalWeight'
        },
        {
          title: '发运状态',
          align: 'center',
          width: 100,
          dataIndex: 'shippingStatus',
          scopedSlots: {customRender: 'shippingStatus'}
        },
        {
          title: '装袋状态',
          align: 'center',
          width: 100,
          dataIndex: 'baggingStatus',
          scopedSlots: {customRender: 'baggingStatus'}
        },
        {
          title: '发运时间',
          align: 'center',
          width: 160,
          dataIndex: 'shippingTime'
        }
      ],
      url: {
        selectData: "/ndt/module/sortingBox/page",
        deleteData: "",
        exportXlsUrl: ""
      },
      orderModalVisible: false,
      currentBoxNum: ''
    }
  },
  methods: {
    ...mapGetters(["siteInfo", "userInfo"]),
    // 下拉框搜索过滤
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleViewBox(record) {
      this.currentBoxNum = record.boxNum
      this.orderModalVisible = true
    },
    handleOrderModalClose() {
      this.orderModalVisible = false
    },
    getStatusText(status) {
      const statusMap = {
        0: '待发运',
        1: '已发运',
        2: '运输中',
        3: '已到达',
        4: '已完成'
      }
      return statusMap[status] || '未知状态'
    },
    getStatusColor(status) {
      const colorMap = {
        0: 'purple',
        1: 'green',
        2: 'red',
        3: 'orange',
        4: 'blue'
      }
      return colorMap[status] || 'default'
    },
    expandedRowRender(record) {
      return {
        template: `<order-list :box-num="${record.boxNum}" />`
      }
    }
  }
}
</script>

<style scoped>
/* 搜索表单样式 */
.table-page-search-wrapper {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 16px;
}

.search-form {
  margin-bottom: 0;
}

.search-form-item {
  margin-bottom: 16px;
  width: 100%;
}

.search-form-item :deep(.ant-form-item-label) {
  width: 80px;
  text-align: right;
  padding-right: 8px;
}

.search-form-item :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.search-form-item :deep(.ant-input),
.search-form-item :deep(.ant-select) {
  width: 100%;
}

/* 搜索按钮样式 */
.search-buttons {
  display: flex;
  align-items: flex-end;
}

.search-buttons :deep(.ant-form-item-control-wrapper) {
  display: flex;
  align-items: flex-end;
  height: 32px;
}

/* 表格样式 */
.sorting-table {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

/* 表格列对齐优化 */
.sorting-table :deep(.ant-table) {
  table-layout: fixed;
}

.sorting-table :deep(.ant-table-thead > tr > th),
.sorting-table :deep(.ant-table-tbody > tr > td) {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .table-page-search-wrapper {
    padding: 16px;
  }

  .search-form-item :deep(.ant-form-item-label) {
    width: 70px;
  }

  .search-buttons {
    justify-content: center;
  }
}
</style>
